<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path
        d="M6.45,17.45L1,12L6.45,6.55L7.86,7.96L4.83,11H19.17L16.14,7.96L17.55,6.55L23,12L17.55,17.45L16.14,16.04L19.17,13H4.83L7.86,16.04L6.45,17.45Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconArrowLeftRight',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  